
import './../scss/main.scss';// load styles
import {onDOMContentLoaded} from './helpers/dom.js';
import Bell from './elements/Bell.js';

onDOMContentLoaded(() => new Bell());
